import { render } from "./Agradecimentos.vue?vue&type=template&id=452f1f8c&scoped=true"
import script from "./Agradecimentos.vue?vue&type=script&lang=js"
export * from "./Agradecimentos.vue?vue&type=script&lang=js"

import "./Agradecimentos.vue?vue&type=style&index=0&id=452f1f8c&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-452f1f8c"]])

export default __exports__